import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const ErrorModal = ({ open, onClose, error }) => {
    return (
        <Modal open={open} onClose={onClose} size="small">
            <Modal.Header className="bg-red-50 text-red-700">
                Error Submitting Request
            </Modal.Header>
            <Modal.Content>
                <div className="flex flex-col gap-4">
                    <p className="text-red-600">
                        There was an error while submitting your request:
                    </p>
                    <div className="bg-red-50 p-4 rounded-md border border-red-200">
                        <p className="text-red-700">{error}</p>
                    </div>
                    <p>
                        Please try again or contact support if the problem persists.
                    </p>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color="red" onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default ErrorModal;